<template>
    <div class="question-remark">
      <span class="label" v-on:click="show()"><i class="fa fa-exclamation-triangle info-icon"></i> Fehler in der Frage?</span>
      <modal name="question-feedback" 
        :min-width="200"
        :min-height="200"
        :adaptive="true"
        :scrollable="true"
        :reset="true"
        height="auto"
      >
        <form class="form-container" @submit.prevent="sendQuestionRemark">
          <div style="padding: 30px; text-align: center">
            <h1>Teile uns dein Feedback mit!</h1>
            <p>Es gibt keine richtige Antwort oder die Frage ist falsch formuliert? Dann gib uns einfach hier Bescheid!</p>
            <textarea name="remark" rows="3" v-model="remark" required></textarea>
            <div class="buttons center">
              <button type="button" class="numbered" style="width: 220px;" v-on:click="hide()"><span>Schließen</span></button>
              <button type="submit" class="next" v-if="!loading">
                <span>Abschicken</span>
              </button>
              <button type="button" class="numbered" style="width: 220px;" disabled="disabled" v-else>
                <span><i class="fa fa-spinner fa-spin"></i></span>
              </button>
              <div v-if="successMessage" class="success-message">
                {{ this.successMessage }}
              </div>
              <div v-if="errorMessage" class="error-message">
                {{ this.errorMessage }}
              </div>
            </div>
          </div>
        </form>
      </modal>
    </div>
    
</template>

<script>
import axios from 'axios';
import config from '../config.js';
import vmodal from 'vue-js-modal'

export default {
  props: [
    'question_id'
  ],
  data: function() {
    return {
      loading: false,
      remark: '',
      errorMessage: '',
      successMessage: ''
    }
  },
  methods: {
    show () {
      this.$modal.show('question-feedback');
    },
    hide () {
      this.$modal.hide('question-feedback');
    },
    sendQuestionRemark () {
      this.loading = true;
      this.errorMessage = '';
      this.successMessage = '';
      axios.post(
          config.api_url + '/question/remark/' + this.question_id,
          JSON.stringify({ "remark": this.remark })
        )
        .then((response) => {
          this.remark = '';
          this.successMessage = 'Deine Anfrage wurde abgeschickt. Vielen Dank!';
        })
        .catch((error) => {
          this.errorMessage = 'Ups, da ist wohl ein Fehler unterlaufen.';
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
}
</script>

<style type="text/css">
  .question-remark {
    display: block;
    padding-top:10px;
  }
  .label {
    display: inline;
    padding: .2em .6em .3em;
    font-size: 70%;
    font-weight: 700;
    line-height: 1;
    color: #2e2e2e;
    text-align: center;
    white-space: nowrap;
    vertical-align: baseline;
    border-radius: .25em;
    background-color:#eceff4;
}
  .info-icon {
    cursor: pointer;
  }
  
  textarea {
    padding:15px;
    margin-top: 5px;
    width: 80%;
    border: 2px solid #f2f2f2;
  }
  
  .success-message {
    padding: 15px;
    border: 2px solid #02b302;
    color: #02b302;
    margin-top: 15px;
  }
  
  .error-message {
    padding: 15px;
    border: 2px solid #cc0909;
    color: #cc0909;
    margin-top: 15px;
  }
</style>


// WEBPACK FOOTER //
// src/components/QuestionRemark.vue